import { render, staticRenderFns } from "./org-info.vue?vue&type=template&id=0a3f05cb&"
import script from "./org-info.vue?vue&type=script&lang=js&"
export * from "./org-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports